let AbstractLayer = require('./abstract');

/**
 * Класс слоя типа VectorTiledLayer - используется для рендеринга сложных основ на клиентской стороне.
 * Типовое применение - базовая картография, планы и т.п.
 */
class VectorTiledLayer extends AbstractLayer{
  constructor(params){
    super(params);
    this.layer = create(params);
    this.initStore(params);
  }

  /**
   * @param params
   * @param params.className - имя класса
   * @param params.mappings - объект, содержащий трансляцию полей (подстановка)
   */
  initStore(params) {
    this.store = {};
    this.store.className = params.className;
    this.store.layerType = "opengis.layers.vectorTiled";
    this.store.mappings = params.mappings;
    this.store.id = params.id;
  }
}

function create(params){
}

module.exports = VectorTiledLayer;